import { Injectable } from '@angular/core';
import { HttpService } from "./http.service";
import { Router } from "@angular/router";
import { UserDataStoreService } from "./user-data-store.service";

@Injectable({
  providedIn: 'root'
})
export class PasswordResetService {


  constructor(
    private _httpService: HttpService,
    private _router: Router,
    private _userDataStore: UserDataStoreService
  ) {

  }

  public async resetPassword(password: string, email: string, token: string): Promise<{ success: boolean, message: string }> {
    const httpResult = await this._httpService.apiPost<{ success: boolean, message: string }>(`UserManagement/ResetPassword`, {
      Password: password,
      Token: token,
      Email: email
    });

    if (httpResult && httpResult.body.success === true) {
      return httpResult.body;
    }
    else {
      return httpResult.body;
    }
  }

  public async resetPasswordForLoggedInUser(newPassword: string, password: string, email: string): Promise<{ success: boolean, message: string }> {
    const httpResult = await this._httpService.apiPost<{ success: boolean, message: string }>(`UserManagement/ResetPasswordLoggedIn`, {
      Password: password,
      NewPassword: newPassword,
      Email: email
    });

    if (httpResult && httpResult.body.success === true) {
      return httpResult.body;
    }
    else {
      return httpResult.body;
    }
  }
}
